// Diálogos de Por pagar: "pagado por fuera" y la revisión de un depósito sin confirmar.
import type { RetailCommission } from '@fiado/type-kit';
import { formatMoneyCents } from '@/shared/lib/format/money';
import { MAX_REASON } from './adjustmentForm';
import { invalidAmountMessage, pesosToCents } from './pesosInput';

/** El folio del motor de cobro: viaja tal cual al CSV del estado de cuenta; no empieza con guion. */
const FOLIO = /^[A-Za-z0-9][A-Za-z0-9-]{0,39}$/;

export interface PaidOutsideErrors {
    amount?: string;
    reason?: string;
}

export function validatePaidOutside(
    amount: string,
    reason: string,
    pendingCents: number,
): PaidOutsideErrors {
    const errors: PaidOutsideErrors = {};
    const cents = pesosToCents(amount);
    if (amount.trim() === '' || (cents !== null && cents <= 0))
        errors.amount = 'Pon un monto mayor que 0.';
    else if (cents === null) errors.amount = invalidAmountMessage(amount);
    else if (cents > pendingCents)
        errors.amount = `No puede pasar del pendiente (${formatMoneyCents(pendingCents)}).`;
    if (reason.trim() === '') errors.reason = 'El motivo es obligatorio: queda en la auditoría.';
    else if (reason.trim().length > MAX_REASON)
        errors.reason = 'El motivo no pasa de 500 caracteres.';
    return errors;
}

export interface ResolutionErrors {
    folio?: string;
    note?: string;
}

export function validateResolution(
    accredited: boolean,
    folio: string,
    note: string,
): ResolutionErrors {
    const errors: ResolutionErrors = {};
    if (accredited) {
        const id = folio.trim();
        if (id === '') errors.folio = 'Escribe el folio del depósito.';
        else if (!FOLIO.test(id))
            errors.folio = 'El folio lleva solo letras, números y guiones, hasta 40.';
    }
    if (note.trim() === '') errors.note = 'La nota es obligatoria: queda en la auditoría.';
    else if (note.trim().length > MAX_REASON) errors.note = 'La nota no pasa de 500 caracteres.';
    return errors;
}

export function toResolveRequest(
    accredited: boolean,
    folio: string,
    note: string,
): RetailCommission.ResolvePaymentRequest {
    return accredited
        ? { accredited: true, transactionId: folio.trim(), note: note.trim() }
        : { accredited: false, note: note.trim() };
}
